<template>
  <div>
    <div v-show="HtmbSh_edit">
      <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">合同模板审核-详情</div>
      <el-button
        style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
        @click="Return">返回</el-button>
      <!-- 主体 -->
      <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
        <!-- 查询框 -->
        <div style="margin-left:3%">
          <div style="height:40px"></div>
          <div style="display:inline-block;margin-left:10px">
            <span>员工合同模板名称</span>
            <el-input v-model="ruleForm.template_name" style="margin-left:10px;width:200px"></el-input>
          </div>

          <div style="display:inline-block;margin-left:20px">
            <span>合同员工分类 </span>
            <el-select v-model="ruleForm.dictionaries_id" style="margin-left:10px;width:200px">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div style="display:inline-block;margin-left:20px">
            <span>生效日期 </span>
            <el-date-picker style="width:200px;margin-left:10px" v-model="ruleForm.template_date" type="date">
            </el-date-picker>
          </div>

          <!-- 按钮 -->
          <div style="display:inline-block;margin-right:100px;float:right">
            <el-button type="goon" @click="tongyi('ruleForm')">同意</el-button>
            <el-button type="addbtn" @click="bohui()">驳回</el-button>
          </div>
        </div>
        <template>
          <div class="edit_container">
            <!-- 新增时输入 -->
            <quill-editor class="w" style="margin-top:20px" v-model="ruleForm.template_content" ref="myQuillEditor"
              :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
              @change="onEditorChange($event)">
            </quill-editor>
            <!-- 从数据库读取展示 -->
            <div v-html="str" class="ql-editor">
              {{str}}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'; //调用编辑器
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      str: '',
      editorOption: {},
      ruleForm: {
        id: '',
        template_name: '',
        dictionaries_id: '',
        template_date: '',
        template_content: '',
        template_url: '',
        template_state: '',
        reviewer_name: '',
        reviewer_date: '',
        reject_reason: '',
        dictionaries_name: '',
        start_date: '',
        end_date: '',
      },

      HtmbSh_edit: true,
    };
  },
  mounted() {
    let content = ''; // 请求后台返回的内容字符串
    this.str = this.escapeStringHTML(content);
  },
  methods: {
    Return() {
      this.$parent.Return();
      this.$parent.trash();
      this.$parent.Find();
    },
    async tongyi() {
      var url = 'template/UpdateTemplate';
      var record = {
        id: this.ruleForm.id,
        template_state: '3',
      };
      var data = await this.$globals.AxiosPost(url, record);
      if (data === '-2000') {
        this.$message.error('服务器未响应！请稍后重试');
      } else {
        var code = data.code;
        var data = data.data;
        if (code === '200') {
          this.$message.success(data);
          this.Return();
        } else {
          this.$message.warning(data);
        }
      }
    },
    async bohui() {
      var url = 'template/UpdateTemplate';
      var record = {
        id: this.ruleForm.id,
        template_state: '2',
      };
      var data = await this.$globals.AxiosPost(url, record);
      if (data === '-2000') {
        this.$message.error('服务器未响应！请稍后重试');
      } else {
        var code = data.code;
        var data = data.data;
        if (code === '200') {
          this.$message.success(data);
          this.Return();
        } else {
          this.$message.warning(data);
        }
      }
    },
    onEditorReady(editor) {
      // 准备编辑器
    },
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus(event) {
      event.enable(false);
    }, // 获得焦点事件
    onEditorChange() {}, // 内容改变事件
    // 转码
    escapeStringHTML(str) {
      str = str.replace(/&lt;/g, '<');
      str = str.replace(/&gt;/g, '>');
      return str;
    },
  },
  created() {
    this.ruleForm = this.$parent.ruleForm;
  },
};
</script>

<style scoped>
/deep/ .ql-toolbar.ql-snow + .ql-container.ql-snow {
  height: 612px;
  border-top: 1px solid #ccc;
}
/deep/ .ql-toolbar.ql-snow {
  display: none;
}
</style>


// WEBPACK FOOTER //
// HtmbSh_edit.vue?18dcb238